"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserSystemInfo = exports.browserInfo = exports.browserTrueAgent = exports.browserUserAgent = void 0;
const utils_1 = require("../../utils/utils");
exports.browserUserAgent = () => {
    return navigator.userAgent.toLowerCase() || ``;
};
exports.browserTrueAgent = () => {
    /*eslint-disable*/
    let strBrowser = 'Unknown';
    const strUserAgent = exports.browserUserAgent();
    /* Checks for different browsers, cannot use Try/Catch block */
    if (document.all &&
        document.getElementById &&
        navigator['savePreferences'] &&
        strUserAgent.indexOf('Netfront') < 0 &&
        navigator.appName !== 'Blazer') {
        strBrowser = 'Escape 5';
    }
    else if (navigator.vendor === 'KDE') {
        strBrowser = 'Konqueror';
    }
    else if (document.childNodes &&
        !document.all &&
        !navigator['taintEnabled'] &&
        !navigator['accentColorName']) {
        strBrowser = 'Safari';
    }
    else if (document.childNodes &&
        !document.all &&
        !navigator['taintEnabled'] &&
        navigator['accentColorName']) {
        strBrowser = 'OmniWeb 4.5+';
    }
    else if (navigator['__ice_version']) {
        strBrowser = 'ICEBrowser';
    }
    else if (window.ScriptEngine &&
        ScriptEngine().indexOf('InScript') + 1 &&
        document.createElement) {
        strBrowser = 'iCab 3+';
    }
    else if (window.ScriptEngine &&
        ScriptEngine().indexOf('InScript') + 1) {
        strBrowser = 'iCab 2-';
    }
    else if (strUserAgent.indexOf('hotjava') + 1 &&
        navigator['accentColorName'] === 'undefined') {
        strBrowser = 'HotJava';
    }
    else if (document['layers'] && !document['classes']) {
        strBrowser = 'Omniweb 4.2-';
    }
    else if (document['layers'] &&
        !navigator.mimeTypes['*']) {
        strBrowser = 'Escape 4';
    }
    else if (document['layers']) {
        strBrowser = 'Netscape 4';
    }
    else if (window['opera'] && document.getElementsByClassName) {
        strBrowser = 'Opera 9.5+';
    }
    else if (window['opera'] && window.getComputedStyle) {
        strBrowser = 'Opera 8';
    }
    else if (window['opera'] && document.childNodes) {
        strBrowser = 'Opera 7';
    }
    else if (window['opera']) {
        strBrowser = 'Opera ' + window['opera'].version();
    }
    else if (navigator.appName.indexOf('WebTV') + 1) {
        strBrowser = 'WebTV';
    }
    else if (strUserAgent.indexOf('netgem') + 1) {
        strBrowser = 'Netgem NetBox';
    }
    else if (strUserAgent.indexOf('opentv') + 1) {
        strBrowser = 'OpenTV';
    }
    else if (strUserAgent.indexOf('ipanel') + 1) {
        strBrowser = 'iPanel MicroBrowser';
    }
    else if (document.getElementById && !document.childNodes) {
        strBrowser = 'Clue browser';
    }
    else if (navigator.product && navigator.product.indexOf('Hv') === 0) {
        strBrowser = 'Tkhtml Hv3+';
    }
    else if (typeof InstallTrigger !== 'undefined') {
        strBrowser = 'Firefox';
    }
    else if (window.atob) {
        strBrowser = 'Internet Explorer 10+';
    }
    else if (XDomainRequest && window.performance) {
        strBrowser = 'Internet Explorer 9';
    }
    else if (XDomainRequest) {
        strBrowser = 'Internet Explorer 8';
    }
    else if (document.documentElement &&
        document.documentElement.style.maxHeight !== 'undefined') {
        strBrowser = 'Internet Explorer 7'; // xxxxx
    }
    else if (document.compatMode && document.all) {
        strBrowser = 'Internet Explorer 6'; // xxxxx
    }
    else if (window['createPopup']) {
        strBrowser = 'Internet Explorer 5.5';
    }
    else if (window['attachEvent']) {
        strBrowser = 'Internet Explorer 5';
    }
    else if (document.all &&
        navigator.appName !== 'Microsoft Pocket Internet Explorer') {
        strBrowser = 'Internet Explorer 4';
    }
    else if (strUserAgent.indexOf('msie') + 1 &&
        window['ActiveXObject']) {
        strBrowser = 'Pocket Internet Explorer';
    }
    else if (document.getElementById &&
        (strUserAgent.indexOf('netfront') + 1 ||
            navigator.appName === 'Blazer' ||
            navigator.product === 'Gecko' ||
            navigator.appName.indexOf('PSP') + 1 ||
            navigator.appName.indexOf('PLAYSTATION 3') + 1)) {
        strBrowser = 'NetFront 3+';
    }
    else if (navigator.product === 'Gecko' &&
        !navigator['savePreferences']) {
        strBrowser = 'Gecko engine (Mozilla, Netscape 6+ etc.)';
    }
    else if (window['chrome']) {
        strBrowser = 'Chrome';
    }
    return strBrowser;
};
function browserInfo() {
    var browser, userAgentString, userAgentStringLC, browserName, browserVersion, browserMajorVersion, nameOffset, verOffset, ix;
    browser = {
        name: ``,
        majorVersion: ``,
    };
    try {
        if (navigator) {
            // browser
            userAgentString = navigator.userAgent;
            userAgentStringLC = userAgentString.toLowerCase();
            browserName = navigator.appName;
            browserVersion = '' + parseFloat(navigator.appVersion);
            browserMajorVersion = parseInt(navigator.appVersion, 10);
            // Opera
            if ((verOffset = userAgentStringLC.indexOf('opera')) != -1) {
                browserName = 'Opera';
                browserVersion = userAgentString.substring(verOffset + 6);
                if ((verOffset = userAgentStringLC.indexOf('version')) != -1) {
                    browserVersion = userAgentString.substring(verOffset + 8);
                }
            }
            // Opera Next
            if ((verOffset = userAgentStringLC.indexOf('opr')) != -1) {
                browserName = 'Opera';
                browserVersion = userAgentString.substring(verOffset + 4);
            }
            // Edge
            else if ((verOffset = userAgentStringLC.indexOf('edge')) != -1) {
                browserName = 'Microsoft Edge';
                browserVersion = userAgentString.substring(verOffset + 5);
            }
            // MSIE
            else if ((verOffset = userAgentStringLC.indexOf('msie')) != -1) {
                browserName = 'Internet Explorer';
                browserVersion = userAgentString.substring(verOffset + 5);
            }
            // Chrome
            else if ((verOffset = userAgentStringLC.indexOf('chrome')) != -1) {
                browserName = 'Chrome';
                browserVersion = userAgentString.substring(verOffset + 7);
            }
            // Safari
            else if ((verOffset = userAgentStringLC.indexOf('safari')) != -1) {
                browserName = 'Safari';
                browserVersion = userAgentString.substring(verOffset + 7);
                if ((verOffset = userAgentStringLC.indexOf('version')) != -1) {
                    browserVersion = userAgentString.substring(verOffset + 8);
                }
            }
            // Firefox
            else if ((verOffset = userAgentStringLC.indexOf('firefox')) != -1) {
                browserName = 'Firefox';
                browserVersion = userAgentString.substring(verOffset + 8);
            }
            // MSIE 11+
            else if (userAgentStringLC.indexOf('trident/') != -1) {
                browserName = 'Internet Explorer';
                browserVersion = userAgentString.substring(userAgentString.indexOf('rv:') + 3);
            }
            // Other browsers
            else if ((nameOffset = userAgentString.lastIndexOf(' ') + 1) <
                (verOffset = userAgentString.lastIndexOf('/'))) {
                browserName = userAgentString.substring(nameOffset, verOffset);
                browserVersion = userAgentString.substring(verOffset + 1);
                if (browserName.toLowerCase() == browserName.toUpperCase()) {
                    browserName = navigator.appName;
                }
            }
            // trim the version string
            if ((ix = browserVersion.indexOf(';')) != -1)
                browserVersion = browserVersion.substring(0, ix);
            if ((ix = browserVersion.indexOf(' ')) != -1)
                browserVersion = browserVersion.substring(0, ix);
            if ((ix = browserVersion.indexOf(')')) != -1)
                browserVersion = browserVersion.substring(0, ix);
            browserMajorVersion = parseInt('' + browserVersion, 10);
            if (isNaN(browserMajorVersion)) {
                browserVersion = '' + parseFloat(navigator.appVersion);
                browserMajorVersion = parseInt(navigator.appVersion, 10);
            }
            if (browserName &&
                browserName !== null &&
                typeof browserName !== 'undefined') {
                browser.name = browserName;
            }
            if (browserMajorVersion &&
                browserMajorVersion != null &&
                typeof browserMajorVersion !== 'undefined') {
                browser.majorVersion = (browserMajorVersion + '').replace(/_/gi, '.');
            }
        }
    }
    catch (err) { }
    return browser;
}
exports.browserInfo = browserInfo;
function browserSystemInfo() {
    let os = ``, osVersion = ``, execArr, v, model, id, clientStrings;
    let osInfo = {
        operatingSystem: ``,
        osVersion: ``,
        cpuBits: ``,
        platform: ``,
        model: ``,
    };
    try {
        // browser
        const navAppVersion = navigator.appVersion;
        const navUserAgent = navigator.userAgent;
        // system
        clientStrings = [
            {
                s: 'Windows 10',
                r: /(Windows 10.0|Windows NT 10.0)/gi,
            },
            {
                s: 'Windows 8.1',
                r: /(Windows 8.1|Windows NT 6.3)/gi,
            },
            {
                s: 'Windows 8',
                r: /(Windows 8|Windows NT 6.2)/gi,
            },
            {
                s: 'Windows 7',
                r: /(Windows 7|Windows NT 6.1)/gi,
            },
            {
                s: 'Windows Vista',
                r: /Windows NT 6.0/gi,
            },
            {
                s: 'Windows Server 2003',
                r: /Windows NT 5.2/gi,
            },
            {
                s: 'Windows XP',
                r: /(Windows NT 5.1|Windows XP)/gi,
            },
            {
                s: 'Windows 2000',
                r: /(Windows NT 5.0|Windows 2000)/gi,
            },
            {
                s: 'Windows ME',
                r: /(Win 9x 4.90|Windows ME)/gi,
            },
            {
                s: 'Windows 98',
                r: /(Windows 98|Win98)/gi,
            },
            {
                s: 'Windows 95',
                r: /(Windows 95|Win95|Windows_95)/gi,
            },
            {
                s: 'Windows NT 4.0',
                r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/gi,
            },
            {
                s: 'Windows CE',
                r: /Windows CE/gi,
            },
            {
                s: 'Windows 3.11',
                r: /Win16/gi,
            },
            {
                s: 'Android',
                r: /Android/gi,
            },
            {
                s: 'BlackBerry',
                r: /BlackBerry/gi,
            },
            {
                s: 'Open BSD',
                r: /OpenBSD/gi,
            },
            {
                s: 'Sun OS',
                r: /SunOS/gi,
            },
            {
                s: 'Linux',
                r: /(Linux|X11)/gi,
            },
            {
                s: 'iOS',
                r: /(iPhone|iPad|iPod)/gi,
            },
            {
                s: 'Mac OS X',
                r: /Mac OS X/gi,
            },
            {
                s: 'Mac OS',
                r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/gi,
            },
            {
                s: 'QNX',
                r: /QNX/gi,
            },
            {
                s: 'UNIX',
                r: /UNIX/gi,
            },
            {
                s: 'BeOS',
                r: /BeOS/gi,
            },
            {
                s: 'OS/2',
                r: /OS\/2/gi,
            },
            {
                s: 'Kindle',
                r: /kindle/gi,
            },
            {
                s: 'PlayStation',
                r: /PlayStation/gi,
            },
            {
                s: 'Wii',
                r: /wii/gi,
            },
            {
                s: 'Bot',
                r: /(bot|robot|crawler|crawling|spider|nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/gi,
            },
        ];
        for (id in clientStrings) {
            const cs = clientStrings[id];
            if (cs.r.test(navUserAgent)) {
                os = cs.s;
                break;
            }
        }
        if (/Windows/gi.test(os)) {
            osVersion = utils_1.getArrIndexValue(/Windows (.*)/gi.exec(os), 1);
            os = 'Windows';
        }
        switch (os) {
            case 'Mac OS X':
                osVersion = utils_1.getArrIndexValue(/Mac OS X (10[\.\_\d]+)/gi.exec(navUserAgent), 1);
                break;
            case 'Android':
                osVersion = utils_1.getArrIndexValue(/Android ([\.\_\d]+)/gi.exec(navUserAgent), 1);
                model = utils_1.getArrIndexValue(/Android.*;(.*)Build/gi.exec(navUserAgent), 1);
                break;
            case 'BlackBerry':
                osVersion = utils_1.getArrIndexValue(/Version\/([\.\_\d]{1,5})/gi.exec(navUserAgent), 1);
                if (utils_1.isBlank(osVersion)) {
                    osVersion = utils_1.getArrIndexValue(/\/([\.\_\d]{1,5})/gi.exec(navUserAgent), 1);
                }
                model = utils_1.getArrIndexValue(/;.*BlackBerry(.*);/gi.exec(navUserAgent), 1);
                if (utils_1.isBlank(model)) {
                    model = utils_1.getArrIndexValue(/BlackBerry([\d]+)/gi.exec(navUserAgent), 1);
                }
                break;
            case 'iOS':
                execArr = /OS (\d+)_(\d+)_?(\d+)?/gi.exec(navUserAgent);
                v = utils_1.getArrIndexValue(execArr, 1);
                osVersion = '';
                if (!utils_1.isBlank(v)) {
                    osVersion = v;
                }
                v = utils_1.getArrIndexValue(execArr, 2);
                if (!utils_1.isBlank(v)) {
                    if (utils_1.isBlank(osVersion)) {
                        osVersion = v;
                    }
                    else {
                        osVersion = osVersion + '.' + v;
                    }
                }
                v = utils_1.getArrIndexValue(execArr, 3);
                if (!utils_1.isBlank(v)) {
                    if (utils_1.isBlank(osVersion)) {
                        osVersion = v;
                    }
                    else {
                        osVersion = osVersion + '.' + v;
                    }
                }
                break;
        }
        if (os && os != null && typeof os !== 'undefined') {
            osInfo.operatingSystem = os;
        }
        if (osVersion && osVersion != null && typeof osVersion !== 'undefined') {
            if (osVersion.trim().length > 0) {
                osInfo.osVersion = osVersion.trim().replace(/_/gi, '.');
            }
        }
        if (navigator) {
            if (navigator.platform) {
                /* navigator.platform is supported by all major browsers */
                osInfo.platform = navigator.platform;
                const platformLC = navigator.platform.toLowerCase();
                if (platformLC.indexOf('x64') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('wow64') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('win64') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('win32') !== -1) {
                    osInfo.cpuBits = '32 bits';
                }
                else if (platformLC.indexOf('x64') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('x32') !== -1) {
                    osInfo.cpuBits = '32 bits';
                }
                else if (platformLC.indexOf('x86') !== -1) {
                    osInfo.cpuBits = '32 bits*';
                }
                else if (platformLC.indexOf('ppc') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('alpha') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('68k') !== -1) {
                    osInfo.cpuBits = '64 bits';
                }
                else if (platformLC.indexOf('iphone') !== -1) {
                    osInfo.cpuBits = '32 bits';
                }
                else if (platformLC.indexOf('android') !== -1) {
                    osInfo.cpuBits = '32 bits';
                }
            }
        }
        if (model && model !== null && typeof model !== 'undefined') {
            if (model.trim().length > 0) {
                osInfo.model = model.trim();
            }
        }
        if (osInfo.model === '')
            delete osInfo.model;
        if (osInfo.cpuBits === '')
            delete osInfo.cpuBits;
    }
    catch (err) { }
    return osInfo;
}
exports.browserSystemInfo = browserSystemInfo;
//# sourceMappingURL=user-agent.js.map